module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori3-35432e1aede1517c4201b5979aace426.jpg";